import { combineReducers } from "redux";
import notice from "../features/admin/notice/notice/slice";

const Notices = combineReducers({
  notice: notice,
});

export default Notices;
